import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postPatientNote = async (newData) => {
  const apiURL = API_HOST + '/patient_notes';
  const { token, userID } = useCurrentUser();

  // console.log('saving ');
  try {
    const { data } = await axios.post(
      apiURL,
      {
        patient_note: newData,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
